import type { AutoResolvedSuggestion } from '@this+that/models';
import log from 'loglevel';

import { useAutoResolvedSuggestionsStore } from '../../store/DoBox/useAutoResolvedSuggestionsStore';

export type GetAutoResolvedSuggestions = (
  taskGroupId: string,
) => Promise<AutoResolvedSuggestion[]>;

export async function loadAutoResolvedSuggestions(
  getFn: GetAutoResolvedSuggestions,
  taskGroupId: string,
): Promise<void> {
  const store = useAutoResolvedSuggestionsStore.getState();
  store.setLoading(true);
  try {
    const items = await getFn(taskGroupId);
    useAutoResolvedSuggestionsStore.getState().replaceItems(taskGroupId, items);
  } catch (error) {
    log.error('Error loading auto-resolved suggestions:', error);
    throw error;
  } finally {
    useAutoResolvedSuggestionsStore.getState().setLoading(false);
  }
}
